export default class ProcessInputModel {

  public tempState: any;
  public tempStateMsisdnField: string;
  public inputId: string;
  public showReloadIcon: boolean;
  public msisdnLabel: string;
  public inputLabel: string;
  public submitNumber: Function;

  constructor(_tempState: any) {
    this.tempState = _tempState;
  }

}
